import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppTableContainer from '@nxsys/components/AppTableContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { ColumnsType } from 'antd/es/table';
import React, { useMemo } from 'react';
import UploadedFileInformation from './UploadedFileInformation';
import { IMPORT_COLUMNS_WIDTH, IMPORT_SCREEN_TYPE } from '../constants';

type ViewImportedFileProps = {
  isOpen: boolean;
  toggle: () => void;
  resultData: IImportAgency | IImportProspect | null;
  importScreenType: IMPORT_SCREEN_TYPE;
};

const ViewImportedFile: React.FC<ViewImportedFileProps> = ({
  isOpen,
  toggle,
  resultData,
  importScreenType,
}) => {
  const { messages } = useTypedIntl();

  const {
    data = [],
    fileName,
    fileSize,
    totalRecords = 0,
    headersImportFile,
  } = resultData || {};

  const columns: ColumnsType<any> = useMemo(() => {
    return (
      headersImportFile?.map((columnHeader, index) => ({
        key: `${columnHeader}_${index}`,
        title: <div className="truncate">{columnHeader}</div>,
        dataIndex: index,
        width:
          IMPORT_COLUMNS_WIDTH?.[
            columnHeader as keyof typeof IMPORT_COLUMNS_WIDTH
          ] ?? 200,
      })) ?? []
    );
  }, [headersImportFile, messages]);

  const dataTable = data.length > 1 ? data?.slice(1) : [];

  return (
    <AppModalContainer
      isOpen={isOpen}
      toggle={toggle}
      title={messages['bulkUpdate.modal.fileInformation']}
      width="90%"
    >
      <UploadedFileInformation
        fileName={fileName}
        fileSize={fileSize}
        totalRecords={totalRecords}
        hideFileSize
      />

      <AppTableContainer
        data={dataTable}
        loading={false}
        page={0}
        total={totalRecords}
        pageSize={totalRecords}
        columns={columns}
        {...(importScreenType === IMPORT_SCREEN_TYPE.AGENCY
          ? { scroll: { x: 10000, y: 500 } }
          : importScreenType === IMPORT_SCREEN_TYPE.PROSPECT
            ? {}
            : {})}
        {...(totalRecords > 1000 ? { virtual: true } : {})}
      />
    </AppModalContainer>
  );
};

export default ViewImportedFile;
